import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiFillCheckCircle } from "react-icons/ai";

import {
  updateDeliveryCalcMethod,
  updateDeliveryFee,
} from "../../../Store/Modules/Store/Actions";
import { Container } from "./style";

function SelectWithBadge({ selected, children, ...props }) {
  return (
    <span {...props}>
      {children}
      {selected && (
        <span class="badge" style={{ marginLeft: "10px", paddingRight: "0px" }}>
          <AiFillCheckCircle style={{ color: "orange", fontSize: "20px" }} />
        </span>
      )}
    </span>
  );
}

export default function DeliveryTaxOptions({ onChange }) {
  const dispatch = useDispatch();
  const { deliveryFee, isLoading, deliveryCalcMethod } = useSelector(
    (state) => state.store
  );
  const [selected, setSelected] = React.useState(
    deliveryFee === 0 ? "free" : deliveryCalcMethod
  );

  const isSelected = React.useCallback(
    (taxOption) => {
      return selected === taxOption;
    },
    [selected]
  );

  const handleSelected = React.useCallback(
    (option) => () => {
      setSelected(option);
      dispatch(updateDeliveryCalcMethod(option));
      onChange(option);
    },
    []
  );

  const handleSelectFixed = React.useCallback(() => {
    setSelected("fixed");
    onChange("fixed");
    dispatch(updateDeliveryFee(1));
  }, []);

  const handleSelectFree = React.useCallback(() => {
    setSelected("free");
    onChange("free");
    dispatch(updateDeliveryFee(0));
  }, []);

  return (
    <Container>
      <div>
        <SelectWithBadge
          onClick={handleSelectFree}
          selected={isSelected("free")}
        >
          Grátis
        </SelectWithBadge>
        <SelectWithBadge
          onClick={handleSelectFixed}
          selected={isSelected("fixed")}
        >
          Fixa
        </SelectWithBadge>
        <SelectWithBadge
          onClick={handleSelected("by-neighborhood")}
          selected={isSelected("by-neighborhood")}
        >
          Por Bairros
        </SelectWithBadge>
      </div>
    </Container>
  );
}
